var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 1.5,
    fill: "#EDEDF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99859 4.20002C8.97183 4.19993 8.94532 4.20434 8.9205 4.21298L4.32825 5.86142C4.28653 5.87636 4.25158 5.9027 4.22872 5.93643C4.20586 5.97017 4.19634 6.00945 4.20161 6.0483C4.47723 8.04645 5.06744 9.81287 5.88193 11.1658C6.6964 12.5187 7.73803 13.4684 8.93911 13.792C8.97891 13.8027 9.02149 13.8027 9.0613 13.792C10.2624 13.4684 11.302 12.5187 12.1165 11.1658C12.9309 9.81287 13.5232 8.04645 13.7988 6.0483C13.804 6.00941 13.7945 5.97009 13.7715 5.93635C13.7486 5.90262 13.7135 5.8763 13.6718 5.86142L9.0795 4.21298C9.0538 4.20402 9.02629 4.19961 8.99859 4.20002ZM7.51515 10.8L8.99316 9.98518L10.4852 10.8L10.2037 9.06666L11.4002 7.83703L9.7392 7.58518L8.99316 6L8.26119 7.58518L6.6002 7.83703L7.79668 9.06666L7.51515 10.8Z",
    fill: "#85868E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 1.5,
    stroke: "#C8C9CE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.b8aca823.svg";
export { ForwardRef as ReactComponent };